export enum MaxLength {
  SecurityName = 255,
}
